/**
 * Blade Slider initialization
 */
document.addEventListener( 'DOMContentLoaded', function() {
	const slider = document.querySelector( '.blade-slider' );
	if ( ! slider ) {
		return;
	}
	
	var tnsSlider = tns( {
		container: '.blade-slider',
		items: 1.1,
		slideBy: '1',
		mouseDrag: true,
		loop: false,
		nav: false,
		responsive: {
			768: {
				items: 1.5,
			},
		},
	} );

	window.initTnsAccessibility( tnsSlider );
} ); 